import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import './styles.css'

function Button(props) {
  const {
    children,
    title,
    type,
    disabled,
    onClick,
    className,
    id
  } = props
  
  return (
    <a
      className={className}
      styleName={cn('button', `${type}`, { disabled })}
      onClick={onClick}
      title={title}
      id={id}
    >
      {children}
    </a>
  )
}

Button.defaultProps = {
  children: 'Button',
  title: '',
  type: 'ok',
  disabled: false,
  onClick: () => {}
}

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.oneOf(['ok', 'go', 'cancel', 'decline'])
}

export default Button
